var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChronometre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stopwatch-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.6,134.1l28.07-38.42a21.33,21.33,0,1,0-34.45-25.17l-29.1,39.83A211.7,211.7,0,0,0,277.33,86.4V42.67H320A21.33,21.33,0,1,0,320,0H192a21.33,21.33,0,1,0,0,42.67h42.67V86.4C127,97.13,42.67,188.23,42.67,298.67,42.67,416.3,138.37,512,256,512s213.33-95.7,213.33-213.33A213,213,0,0,0,391.6,134.1ZM256,469.33c-94.1,0-170.67-76.56-170.67-170.67S161.9,128,256,128s170.67,76.56,170.67,170.67S350.1,469.33,256,469.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.33,289.83v-76.5a21.33,21.33,0,1,0-42.67,0v85.33a21.34,21.34,0,0,0,6.25,15.08l64,64a21.33,21.33,0,1,0,30.17-30.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronometre);
export default __webpack_public_path__ + "static/media/chronometre.a98ae854.svg";
export { ForwardRef as ReactComponent };